import { render, staticRenderFns } from "./DisciplinasCarousel.vue?vue&type=template&id=e4b47566&scoped=true&"
import script from "./DisciplinasCarousel.vue?vue&type=script&lang=js&"
export * from "./DisciplinasCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4b47566",
  null
  
)

export default component.exports